
<div class="cookies-page">
  <div class="cookie-header">
    <h1 class="cookie-header__title">{{ 'cookies-modal.title' | translate }}</h1>
    <hr class="cookie-header__separator" />
  </div>

  <div class="cookie-content">

    <ion-grid>
      <ion-row>
        <ion-col text-center class="p-0">
          <div class="policity-content">
            <p [innerHTML]="'cookies-modal.section-1' | translate"></p>
            <p>
              {{ 'cookies-modal.section-1-text-1' | translate }}
              <a (click)="openCookiesPage()" class="externo">{{
                'cookies-modal.link' | translate
              }}</a
              >.
              {{ 'cookies-modal.section-1-text-2' | translate }}
            </p>
          </div>
  
          <div
            class="policity-content"
            [innerHTML]="'cookies-modal.section-2' | translate"
          ></div>
          <div
            class="policity-content"
            [innerHTML]="'cookies-modal.section-3' | translate"
          ></div>
        </ion-col>
      </ion-row>
    </ion-grid>

</div>










